import React, { Component } from 'react';

class ErreurPause extends Component {
    render() {
        return (
            <div className="page-erreur" dangerouslySetInnerHTML={{__html: this.props.config[`MES_SUSPEN_${this.props.lang}`]}} />
        );
    }
}

export default ErreurPause;